import React from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import { ProxyConfig } from '../components/ProxyConfig';
import { GeneralSettings } from '../components/GeneralSettings';
import { CommonHeadersUserAgents } from '../components/CommonHeadersUserAgents';
import { DefinitionSync } from '../components/DefinitionSync';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`settings-tabpanel-${index}`}
      aria-labelledby={`settings-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

export const Settings: React.FC = () => {
  const [value, setValue] = React.useState(0);

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label="settings tabs">
          <Tab label="Proxy Configuration" />
          <Tab label="General Settings" />
          <Tab label="Common Headers & User Agents" />
          <Tab label="Advanced" />
        </Tabs>
      </Box>

      <TabPanel value={value} index={0}>
        <ProxyConfig />
      </TabPanel>

      <TabPanel value={value} index={1}>
        <GeneralSettings />
      </TabPanel>

      <TabPanel value={value} index={2}>
        <CommonHeadersUserAgents />
      </TabPanel>

      <TabPanel value={value} index={3}>
        <DefinitionSync />
      </TabPanel>
    </Box>
  );
};
